<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame pb" id="_idContainer002">
<p class="ebook-toc" id="_idParaDest-1"><a id="_idTextAnchor000"></a> </p>
</div>
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="amatic-bold p3"><span class="CharOverride-1">To Anne Burke Sadow</span></p>
<p class="amatic-bold"><span class="CharOverride-1">With love and thanks</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SoWhosCounting_epub_final.vue?3d7f1e4b